export default class Entenda_raizes {
    constructor() {
        this.sections = document.querySelectorAll('.component-entenda_o_raizes');
        this.ready();
    }

    ready() {

        this.sections.forEach(section => {
            const itens = section.querySelectorAll('.item-raizes');
            const modals = section.querySelectorAll('.modal-singla');
            const closes = section.querySelectorAll('.modal-singla .btnCloseModal');

            if (itens.length > 0 && modals.length > 0) {
                itens.forEach((item) => {
                    item.addEventListener('click', () => {
                        const singla = item.dataset.singla;

                        if (singla) {
                            const modal = section.querySelector(`.modal-singla[data-singla="${singla}"]`);

                            if (modal) {
                                modals.forEach((m) => {
                                    m.classList.remove('active');
                                    modal.classList.add('active');
                                });
                            }
                        }
                    })
                });

                closes.forEach((close) => {
                    close.addEventListener('click', () => {
                        modals.forEach((m) => {
                            m.classList.remove('active');
                        });
                    })
                });
            }
        })

    }

}

if (document.querySelector('.component-entenda_o_raizes')) {
    new Entenda_raizes();
}